import { defineComponent as _defineComponent } from 'vue'
import { CombinedPresets } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import { PresetCategory } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import { PRESET_CATEGORIES } from '@/components/DesignStudio/ImageEffectsProperties/core/presets';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BodyPresetGridThumbnailHover',
  props: {
    preset: null
  },
  setup(__props: any) {

const props = __props as {
    preset: CombinedPresets;
};



const isFree = computed(() => {
    return props.preset.presets?.every((awd) => awd.isFree);
});

const getCategoryLabel = (category: PresetCategory): string => {
    const categoryInfo = PRESET_CATEGORIES.find((cat) => cat.category === category);
    return categoryInfo?.label || category;
};

return { __sfc: true,props, isFree, getCategoryLabel }
}

})